import React from 'react';
export function HeroSection() {
  return <section className="relative pt-12 pb-0 md:pt-28 overflow-hidden bg-[#F4EDE4]" data-id="element-76">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[700px] h-[450px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(184,149,106,0.22) 0%, transparent 70%)'
    }} data-id="element-77" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-78">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex items-center gap-2 px-4 py-1.5 sm:px-5 sm:py-2 rounded-full bg-white border border-[#E8D5C4] text-[#5A2A3D] text-[10px] sm:text-xs font-bold tracking-[0.2em] mb-5 sm:mb-8 shadow-sm uppercase" data-id="element-79">
          <span className="w-1.5 h-1.5 rounded-full bg-[#B8956A] animate-pulse" data-id="element-80" />
          Kit Lashista · Tu Agenda Profesional™
        </div>

        {/* Headline (promise) */}
        <h1 className="animate-fade-in-up delay-100 text-3xl sm:text-5xl md:text-7xl text-[#2D1A22] leading-[1.05] tracking-tight mb-5 sm:mb-6" data-id="element-81">
          La fórmula N°1 para eliminar cancelaciones
          <br data-id="element-82" />
          <span className="italic text-[#5A2A3D]" data-id="element-83">en solo 1 SEMANA</span>
        </h1>

        {/* Product Mockup — placed BETWEEN promise and subtitle, at ~70% size */}
        <div className="animate-fade-in-up delay-200 flex justify-center mb-5 sm:mb-6" data-id="element-84">
          <img src="https://cdn.magicpatterns.com/uploads/nvZoxomZ8zdEsDhcjawDAL/Captura_de_pantalla_2026-05-25_a_la(s)_12.59.58_p._m._-_Editado_(1).png" alt="Kit Lashista Tu Agenda Profesional — El kit más completo para lashistas" className="w-full max-w-md sm:max-w-lg drop-shadow-2xl" loading="eager" decoding="async" data-id="element-85" />
        </div>

        {/* Subtitle */}
        <p className="animate-fade-in-up delay-250 text-sm sm:text-base md:text-lg text-[#5A4A4F] max-w-2xl mx-auto leading-relaxed mb-7 sm:mb-10" data-id="element-86">
          El sistema N°1 para lashistas argentinas — Filtro + Políticas + Agenda
          + Rescate + Blindaje + Élite.
        </p>

        {/* Product Card — compact on mobile */}
        <div className="animate-fade-in-up delay-300 bg-white border border-[#E8D5C4] rounded-2xl p-4 sm:p-6 md:p-10 mb-6 relative overflow-hidden shadow-lg" data-id="element-87">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#B8956A] via-[#C9A97A] to-[#B8956A]" data-id="element-88" />
          <div className="text-[10px] tracking-[0.25em] text-[#B8956A] font-bold uppercase mb-2 sm:mb-3" data-id="element-89">
            Sistema Digital 2026
          </div>
          <h2 className="text-xl sm:text-2xl md:text-4xl text-[#2D1A22] mb-3 sm:mb-4 leading-tight" data-id="element-90">
            Kit Lashista <span className="italic" data-id="element-91">Tu Agenda Profesional</span>™
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#5A2A3D] font-medium mb-3 sm:mb-5 italic" data-id="element-92">
            Filtro + Políticas + Agenda + Rescate + Blindaje + Élite
          </p>
          <p className="text-[#5A4A4F] text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-93">
            Políticas + scripts + sistema de reservas + protección física +
            mentalidad de dueña listos para implementar.
          </p>
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-350 flex flex-col items-center mb-7 sm:mb-10" data-id="element-94">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 text-sm sm:text-base md:text-lg font-bold text-white hover:bg-[#6B3D4F] rounded-full transition-all active:scale-95 shadow-xl tracking-wider uppercase bg-[#ED4A89]" data-id="element-95">
            → Quiero mi Kit ahora
          </a>
          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 md:gap-4 mt-4 sm:mt-6 text-[11px] sm:text-xs md:text-sm font-medium text-[#5A4A4F]" data-id="element-96">
            <span data-id="element-97">🛡️ Garantía 30 días</span>
            <span className="hidden sm:inline text-[#E8D5C4]" data-id="element-98">|</span>
            <span data-id="element-99">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-[#E8D5C4]" data-id="element-100">|</span>
            <span data-id="element-101">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Badges */}
        <div className="animate-fade-in-up delay-400 flex flex-wrap justify-center gap-1.5 sm:gap-2 md:gap-3 mb-10 sm:mb-16" data-id="element-102">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Para lashistas argentinas', '📚 4 Tomos + 4 Bonos + 1 Upsell', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-2.5 py-1 sm:px-3 sm:py-1.5 md:px-4 md:py-2 rounded-full bg-[#FAF6F0] text-[#5A4A4F] text-[10px] sm:text-xs md:text-sm font-medium border border-[#E8D5C4]" data-id="element-103">
              {b}
            </span>)}
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-[#E8D5C4] bg-white/70 backdrop-blur-sm" data-id="element-104">
        <div className="max-w-5xl mx-auto px-4" data-id="element-105">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 sm:gap-y-6 py-6 sm:py-8 md:py-10" data-id="element-106">
            {[{
            val: '+500',
            label: 'lashistas ya lo tienen'
          }, {
            val: '4',
            label: 'Tomos completos'
          }, {
            val: '4',
            label: 'Bonos incluidos'
          }, {
            val: '4.9/5 ★',
            label: 'calificación'
          }].map((s, i) => <div key={i} className="text-center px-2 sm:px-4" data-id="element-107">
                <div className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] mb-1" data-id="element-108">
                  {s.val}
                </div>
                <div className="text-[9px] sm:text-[10px] md:text-xs text-[#5A4A4F] font-medium uppercase tracking-[0.18em]" data-id="element-109">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}